import BulkActionsDrawerItem from "components/BulkActions/Drawer/Item";
import BulkActionsDrawerItemLink from "components/BulkActions/Drawer/Item/Link";
import BulkActionsDrawerItemStatusIcon from "components/BulkActions/Drawer/Item/StatusIcon";
import BulkActionsDrawerItemStopExecutionButton from "components/BulkActions/Drawer/Item/StopExecutionButton";
import { BulkActionResultsMetadata } from "components/BulkActions/helpers";
import {
  BulkActionResultTabs,
  BulkActionsResult,
  BulkActionsStep,
} from "components/BulkActions/types";
import Box from "ds/components/Box";
import Feedback from "ds/components/Feedback";
import { Stack } from "types/generated";

import { PolledRunState } from "./useBulkRunStatesPolling";

type StacksBulkActionsResultsItemProps = {
  stack: Stack;
  tab: BulkActionResultTabs;
  resultsMetadata?: BulkActionResultsMetadata;
  status: BulkActionsResult;
  stopExecution: () => void;
};

export type StacksBulkActionsResultsPollingItemProps = StacksBulkActionsResultsItemProps & {
  polledState?: PolledRunState;
};

const StacksBulkActionsResultsItem = ({
  stack,
  tab,
  resultsMetadata,
  status,
  stopExecution,
}: StacksBulkActionsResultsItemProps) => {
  const feedbackVariant = status === BulkActionsResult.Failed ? "danger" : "info";

  return (
    <BulkActionsDrawerItem key={stack.id} direction="column" align="start">
      <Box align="center" gap="medium" fullWidth zeroMinWidth>
        <BulkActionsDrawerItemStatusIcon result={status} />
        <BulkActionsDrawerItemLink
          link={`/stack/${stack.id}`}
          text={stack.name}
          step={BulkActionsStep.Results}
          itemCategory={tab}
        />
        <BulkActionsDrawerItemStopExecutionButton onStopExecution={stopExecution} status={status} />
      </Box>

      {resultsMetadata?.message && (
        <Feedback type="banner" variant={feedbackVariant} fullWidth>
          {resultsMetadata.message}
        </Feedback>
      )}
    </BulkActionsDrawerItem>
  );
};

export default StacksBulkActionsResultsItem;
